import React, { useState } from 'react';
import { PlusIcon, SearchIcon, FilterIcon, TagIcon, TrashIcon, PencilIcon, CalendarIcon, PercentIcon, DollarSignIcon, UsersIcon } from 'lucide-react';
export const CouponsManagement = () => {
  const [showAddModal, setShowAddModal] = useState(false);
  // Sample data for coupons
  const coupons = [{
    id: 'COUPON-12345',
    code: 'SUMMER20',
    type: 'Percentage',
    value: '20%',
    minPurchase: '$50.00',
    startDate: '2023-05-01',
    endDate: '2023-06-30',
    usageLimit: 1000,
    usageCount: 345,
    status: 'Active'
  }, {
    id: 'COUPON-12346',
    code: 'WELCOME10',
    type: 'Percentage',
    value: '10%',
    minPurchase: '$0.00',
    startDate: '2023-01-01',
    endDate: '2023-12-31',
    usageLimit: 5000,
    usageCount: 2134,
    status: 'Active'
  }, {
    id: 'COUPON-12347',
    code: 'FLAT25OFF',
    type: 'Fixed Amount',
    value: '$25.00',
    minPurchase: '$100.00',
    startDate: '2023-04-15',
    endDate: '2023-05-15',
    usageLimit: 500,
    usageCount: 500,
    status: 'Expired'
  }, {
    id: 'COUPON-12348',
    code: 'APPLE15',
    type: 'Percentage',
    value: '15%',
    minPurchase: '$200.00',
    startDate: '2023-05-10',
    endDate: '2023-07-10',
    usageLimit: 2000,
    usageCount: 156,
    status: 'Active'
  }, {
    id: 'COUPON-12349',
    code: 'SAMSUNG10',
    type: 'Percentage',
    value: '10%',
    minPurchase: '$150.00',
    startDate: '2023-05-15',
    endDate: '2023-06-15',
    usageLimit: 1500,
    usageCount: 89,
    status: 'Active'
  }, {
    id: 'COUPON-12350',
    code: 'FREESHIP',
    type: 'Free Shipping',
    value: 'Free Shipping',
    minPurchase: '$75.00',
    startDate: '2023-05-01',
    endDate: '2023-05-31',
    usageLimit: 3000,
    usageCount: 1245,
    status: 'Active'
  }, {
    id: 'COUPON-12351',
    code: 'NEWUSER',
    type: 'Percentage',
    value: '25%',
    minPurchase: '$0.00',
    startDate: '2023-06-01',
    endDate: '2023-06-30',
    usageLimit: 1000,
    usageCount: 0,
    status: 'Scheduled'
  }];
  const getStatusBadgeClass = (status: string) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'bg-green-100 text-green-800';
      case 'expired':
        return 'bg-red-100 text-red-800';
      case 'scheduled':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };
  const getTypeIcon = (type: string) => {
    switch (type.toLowerCase()) {
      case 'percentage':
        return <PercentIcon className="h-4 w-4 text-green-500" data-id="element-1518" />;
      case 'fixed amount':
        return <DollarSignIcon className="h-4 w-4 text-blue-500" data-id="element-1519" />;
      case 'free shipping':
        return <TagIcon className="h-4 w-4 text-purple-500" data-id="element-1520" />;
      default:
        return <TagIcon className="h-4 w-4 text-gray-500" data-id="element-1521" />;
    }
  };
  return <div className="space-y-6" data-id="element-1522">
      <div className="flex justify-between items-center" data-id="element-1523">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1524">Coupons Management</h1>
        <button className="bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700 transition-colors flex items-center" onClick={() => setShowAddModal(true)} data-id="element-1525">
          <PlusIcon className="h-5 w-5 mr-1" data-id="element-1526" />
          Add New Coupon
        </button>
      </div>
      {/* Filters and Search */}
      <div className="bg-white rounded-lg shadow-sm p-4 border border-gray-200" data-id="element-1527">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4" data-id="element-1528">
          <div className="flex flex-col sm:flex-row gap-3" data-id="element-1529">
            <div className="relative" data-id="element-1530">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1531">
                <option value="all" data-id="element-1532">All Status</option>
                <option value="active" data-id="element-1533">Active</option>
                <option value="expired" data-id="element-1534">Expired</option>
                <option value="scheduled" data-id="element-1535">Scheduled</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-1536">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-1537" />
              </div>
            </div>
            <div className="relative" data-id="element-1538">
              <select className="appearance-none pl-3 pr-10 py-2 border border-gray-300 rounded-md bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1539">
                <option value="all" data-id="element-1540">All Types</option>
                <option value="percentage" data-id="element-1541">Percentage</option>
                <option value="fixed" data-id="element-1542">Fixed Amount</option>
                <option value="shipping" data-id="element-1543">Free Shipping</option>
              </select>
              <div className="absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" data-id="element-1544">
                <FilterIcon className="h-4 w-4 text-gray-400" data-id="element-1545" />
              </div>
            </div>
          </div>
          <div className="relative w-full md:w-64" data-id="element-1546">
            <input type="text" placeholder="Search coupons..." className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500" data-id="element-1547" />
            <SearchIcon className="absolute left-3 top-2.5 h-5 w-5 text-gray-400" data-id="element-1548" />
          </div>
        </div>
      </div>
      {/* Coupons Table */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" data-id="element-1549">
        <div className="overflow-x-auto" data-id="element-1550">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1551">
            <thead className="bg-gray-50" data-id="element-1552">
              <tr data-id="element-1553">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1554">
                  Code
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1555">
                  Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1556">
                  Value
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1557">
                  Min Purchase
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1558">
                  Period
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1559">
                  Usage
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1560">
                  Status
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1561">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1562">
              {coupons.map(coupon => <tr key={coupon.id} className="hover:bg-gray-50" data-id="element-1563">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600" data-id="element-1564">
                    {coupon.code}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1565">
                    <div className="flex items-center" data-id="element-1566">
                      {getTypeIcon(coupon.type)}
                      <span className="ml-2 text-sm text-gray-900" data-id="element-1567">
                        {coupon.type}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1568">
                    {coupon.value}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900" data-id="element-1569">
                    {coupon.minPurchase}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1570">
                    <div className="flex items-center text-sm text-gray-500" data-id="element-1571">
                      <CalendarIcon className="h-4 w-4 mr-1" data-id="element-1572" />
                      <span data-id="element-1573">
                        {coupon.startDate} to {coupon.endDate}
                      </span>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1574">
                    <div className="flex items-center text-sm text-gray-500" data-id="element-1575">
                      <UsersIcon className="h-4 w-4 mr-1" data-id="element-1576" />
                      <span data-id="element-1577">
                        {coupon.usageCount} / {coupon.usageLimit}
                      </span>
                    </div>
                    <div className="w-full bg-gray-200 rounded-full h-1.5 mt-1" data-id="element-1578">
                      <div className="bg-blue-600 h-1.5 rounded-full" style={{
                    width: `${coupon.usageCount / coupon.usageLimit * 100}%`
                  }} data-id="element-1579"></div>
                    </div>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap" data-id="element-1580">
                    <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusBadgeClass(coupon.status)}`} data-id="element-1581">
                      {coupon.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium" data-id="element-1582">
                    <div className="flex space-x-2" data-id="element-1583">
                      <button className="text-green-600 hover:text-green-900" data-id="element-1584">
                        <PencilIcon className="h-5 w-5" data-id="element-1585" />
                      </button>
                      <button className="text-red-600 hover:text-red-900" data-id="element-1586">
                        <TrashIcon className="h-5 w-5" data-id="element-1587" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="px-6 py-4 border-t border-gray-200 flex items-center justify-between" data-id="element-1588">
          <div className="text-sm text-gray-700" data-id="element-1589">
            Showing <span className="font-medium" data-id="element-1590">1</span> to{' '}
            <span className="font-medium" data-id="element-1591">{coupons.length}</span> of{' '}
            <span className="font-medium" data-id="element-1592">{coupons.length}</span> results
          </div>
          <div className="flex space-x-2" data-id="element-1593">
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-1594">
              Previous
            </button>
            <button className="px-3 py-1 border border-blue-600 rounded-md bg-blue-600 text-white hover:bg-blue-700" data-id="element-1595">
              1
            </button>
            <button className="px-3 py-1 border border-gray-300 rounded-md bg-white text-gray-700 hover:bg-gray-50" data-id="element-1596">
              Next
            </button>
          </div>
        </div>
      </div>
    </div>;
};